import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { NAV_LINKS, CONTACT } from "../data/content";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.6, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#F8F7F4]/85 backdrop-blur-xl border-b border-[#16281D]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo" className="flex items-baseline gap-2">
          <span className="font-serif text-2xl tracking-tight text-[#16281D]">Taşpınar</span>
          <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#B85C38]">ASM</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.slice(1)}`}
              className="text-sm text-[#4A5D52] hover:text-[#16281D] transition-colors duration-300 relative group"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#B85C38] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="#iletisim"
            data-testid="navbar-phone"
            className="flex items-center gap-2 bg-[#16281D] text-[#F8F7F4] px-5 py-2.5 rounded-full text-sm hover:bg-[#B85C38] transition-colors duration-300"
          >
            <Phone size={14} />
            <span className="hidden sm:inline">{CONTACT.phone}</span>
            <span className="sm:hidden">Ara</span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Menü"
            className="md:hidden w-10 h-10 rounded-full border border-[#16281D]/20 flex items-center justify-center text-[#16281D] bg-[#F8F7F4]/70 backdrop-blur"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.4, ease: [0.76, 0, 0.24, 1] }}
            className="md:hidden overflow-hidden bg-[#F8F7F4] border-b border-[#16281D]/10"
          >
            <div className="px-6 py-6 flex flex-col gap-1">
              {NAV_LINKS.map((link, i) => (
                <motion.a
                  key={link.href}
                  href={link.href}
                  data-testid={`mobile-nav-link-${link.href.slice(1)}`}
                  onClick={() => setOpen(false)}
                  initial={{ opacity: 0, x: -16 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: 0.05 + i * 0.06 }}
                  className="font-serif text-2xl text-[#16281D] py-3 border-b border-[#16281D]/5 flex items-center justify-between"
                >
                  {link.label}
                  <span className="text-[#B85C38] text-sm">→</span>
                </motion.a>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
